const translations = {
    equipment: 'Equipment',
    organization: 'Organization',
    subscription: 'Subscription',
    teamMembers: 'Team Members'
};

export default translations;
